import produce from 'immer';
import * as types from './types';

const INITIAL_STATE = {
  categoriesInstituitions: [],
  instituitionData: null,
  error: null,
  loading: null,
  instituitionsData: {
    data: [],
    totalCount: 0,
  },
  instituitionsOrderBy: null,
  instituitionsSearch: null,
  loadingInstitutions: null,
  optionsPerfil: [],
};

export function instituitions(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    /**
     * ---------------------------------------------------
     *  CATEGORIAS DA INSTITUIÇÃO
     * ---------------------------------------------------
     */

    switch (action.type) {
      case types.LIST_CATEGORIES_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LIST_CATEGORIES_SUCCESS: {
        draft.categoriesInstituitions = action.payload.categoriesInstituitions;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LIST_CATEGORIES_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      /**
       * ---------------------------------------------------
       *  UPLOAD LOGOTIPO INSTITUIÇÃO
       * ---------------------------------------------------
       */

      case types.LOGO_INSTITUTION_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LOGO_INSTITUTION_SUCCESS: {
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LOGO_INSTITUTION_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      /**
       * ---------------------------------------------------
       *  GET INSTITUIÇÃO
       * ---------------------------------------------------
       */

      case types.GET_INSTITUTION_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GET_INSTITUTION_SUCCESS: {
        draft.instituitionData = action.payload.instituitionData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_INSTITUTION_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      /**
       * ---------------------------------------------------
       *  GET INSTITUIÇÕES PARTICIPANTES
       * ---------------------------------------------------
       */

      case types.GET_INSTITUTIONS_REQUEST: {
        draft.instituitionsOrderBy = action?.payload?.instituitionsOrderBy;
        draft.instituitionsSearch = action?.payload?.instituitionsSearch;
        draft.loadingInstitutions = true;
        break;
      }
      case types.GET_INSTITUTIONS_SUCCESS: {
        draft.loadingInstitutions = false;
        draft.instituitionsData = action?.payload?.instituitionsData;
        draft.instituitionsOrderBy = action?.payload?.instituitionsOrderBy;
        draft.instituitionsSearch = action?.payload?.instituitionsSearch;
        draft.error = false;
        break;
      }
      case types.GET_INSTITUTIONS_FAILURE: {
        draft.loadingInstitutions = false;
        draft.error = true;
        break;
      }

      /**
       * ---------------------------------------------------
       *  OPCOES PERFIL HOSPITALAR
       * ---------------------------------------------------
       */

      case types.OPCOES_PERFIL_SUCCESS: {
        draft.optionsPerfil = action?.payload;
        break;
      }
      case types.OPCOES_PERFIL_FAILURE: {
        draft.optionsPerfil = [];
        break;
      }

      default:
        return state;
    }
  });
}
